module.exports = __webpack_public_path__ + "media/img/massenversand-492dab20272a99383787efb16052d949.jpg";